import { frontendURL } from '../../../helper/URLHelper';
import bulkmessageNew from '././pages/BulkMessageNew.vue';
import bulkmessageHistory from './pages/BulkMessageHistory.vue';
import bulkmessageScheduled from './pages/BulkMessageScheduled.vue';
import templateCreator from './pages/TemplateCreator.vue';
import alertResponzaTest from './pages/AlertResponzaTest.vue';
import testeLabels from './pages/testes/testeLabels.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'manager'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/bulk_message/new'),
    name: 'bulkMessage_new',
    component: bulkmessageNew,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/bulk_message/history'),
    name: 'bulkMessage_history',
    component: bulkmessageHistory,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/bulk_message/scheduled'),
    name: 'bulkMessage_scheduled',
    component: bulkmessageScheduled,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/bulk_message/details/:id'),
    name: 'bulkMessage_details',
    component: () => import('./components/BroadcastDetail.vue'),
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/bulk_message/template-creator'),
    name: 'templateCreator',
    component: templateCreator,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/bulk_message/alert-test'),
    name: 'alertResponzaTest',
    component: alertResponzaTest,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/bulk_message/testes/testeLabels'),
    name: 'testeLabels',
    component: testeLabels,
    meta: commonMeta,
  },
  // Redirect old home route to new route
  {
    path: frontendURL('accounts/:accountId/bulk_message/home'),
    redirect: to =>
      frontendURL(`accounts/${to.params.accountId}/bulk_message/new`),
  },
];
